<template>
  <panel-layout
    id="panel"
    :loading="reservations.loading"
    :heading="$t('pages.index.unconfirmedAppointments')"
    :show-footer="false"
  >
    <div class="h-full flex flex-col">
      <o-scroll v-if="reservations" class="p-5">
        <unconfirmed
          v-for="reservation in reservations.items"
          :key="reservation.idReservation"
          :reservation="reservation"
        />

        <p v-if="!reservations.items.length" class="text-sm opacity-80">
          {{ $t('pages.index.noUnconfirmedReservations') }}
        </p>
      </o-scroll>

      <div>
        <o-pagination v-if="reservations" :pager="reservations" container-class="py-3 border-t flex justify-between items-center flex-shrink-0 px-4" />
      </div>
    </div>
  </panel-layout>
</template>
<script setup lang="ts">
// @ts-ignore
import Unconfirmed from '@/components/dashboard/elements/Unconfirmed.vue'
import { TablePager } from '@/_api/lib/pager'
// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'
// @ts-ignore
import { OPagination } from '@/components/elements'
// @ts-ignore
import { SegmentField } from '@/components/fields'

import { usePanel } from '~/composables/usePanel'

const { $api } = useNuxtApp()

const panel = usePanel()

const reservations = ref(new TablePager((page: any) => $api.reservation.unconfirmed({ page }), 20))
const page = ref(1)

onMounted(() => {
  reservations.value.load()
})
</script>
